import { baseFetch } from 'src/utils';

export const getVendorListAPI = async () => {
  const res = await baseFetch('/api/make/vendorlist', {
    method: 'GET',
  });

  if (!res.ok) {
    throw new Error('Failed to fetch vendor list');
  }

  const data: { vendorid: string; show: boolean; displayname: string }[] =
    await res.json();

  const vendors = data
    .map((vendor) => ({
      showVendor: vendor.show,
      vendorId: vendor.vendorid,
      vendorDisplayName: vendor.displayname,
    }))
    .sort((a, b) => a.vendorDisplayName.localeCompare(b.vendorDisplayName));

  return vendors;
};
